import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FarbweltLogo } from "@/components";
import { useFarbwelt, useTestId } from "@/hooks";
import { Box } from "@gemini/core";
export const FarbweltBanner = ({ isDesktop }) => {
    const { bgColor, logo, isFarbweltActive, providerName, textColor } = useFarbwelt();
    const testId = useTestId("Farbwelt.Banner");
    const borderStyle = {
        borderColor: "color.border.disabled",
        borderWidth: "borderWidth.1",
    };
    const hasBanner = isFarbweltActive && (bgColor || logo);
    if (!hasBanner)
        return null;
    return isDesktop ? (_jsxs(Box, { unsafe_style: { backgroundColor: bgColor }, height: "sizing.48", width: "100%", borderTopLeftRadius: "radius.16", borderTopRightRadius: "radius.16", paddingHorizontal: "spacing.32", paddingVertical: "spacing.8", display: {
            "breakpoint.base": "none",
            "breakpoint.lg": "flex",
        }, alignItems: "center", testId: `${testId}.Desktop`, unsafe_className: "FarbweltBannerDesktop", ...borderStyle, borderStyle: "solid", borderBottomWidth: "borderWidth.none", children: [_jsx(FarbweltLogo, { testId: `${testId}.Logo` }), _jsx(Box, { as: "span", marginLeft: "spacing.80", typography: "typography.body.16.bold", color: textColor, children: providerName })] })) : (_jsxs(Box, { unsafe_style: { backgroundColor: bgColor }, width: "100%", marginTop: "-spacing.16", paddingHorizontal: "spacing.16", paddingTop: "spacing.8", paddingBottom: "spacing.24", display: {
            "breakpoint.base": "flex",
            "breakpoint.lg": "none",
        }, position: "relative", alignItems: "center", testId: `${testId}.Mobile`, unsafe_className: "FarbweltBannerMobile", borderTopLeftRadius: "radius.16", borderTopRightRadius: "radius.16", ...borderStyle, borderLeftWidth: "borderWidth.none", borderRightWidth: "borderWidth.none", children: [_jsx(FarbweltLogo, { testId: `${testId}.Logo` }), _jsx(Box, { as: "span", marginLeft: "spacing.80", typography: {
                    "breakpoint.base": "typography.body.14.bold",
                    "breakpoint.md": "typography.body.16.bold",
                }, color: textColor, unsafe_style: {
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    whiteSpace: "pre-line",
                    overflow: "hidden",
                }, children: providerName })] }));
};
